export const TASK_SUCCESS = 'TASK_SUCCESS'
export const TASK_LIST_INITIATED = 'TASK_LIST_INITIATED'
export const TASK_SET_FILTERS = 'TASK_SET_FILTERS'
export const TASK_STATUS_COUNT_SUCCESS = 'TASK_STATUS_COUNT_SUCCESS'
export const TASK_FILE_STATUS = 'TASK_FILE_STATUS'
export const REMOVE_FILE = 'REMOVE_FILE'
export const INIT_TASK_FILE_STATUS = 'INIT_TASK_FILE_STATUS'
